<div class="container">
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Add Third-Party Integration"></aw-bread-crumb>
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }

  <app-unsaved-changes-dialog></app-unsaved-changes-dialog>

  <aw-dialog
    [visible]="openIntegrationInfoDialog"
    [formFieldsData]="formFieldsData"
    [dialogOptions]="dialogOptions"
    (primaryAction)="dialogCloseHandler()"
    ariaLabel="Third-Party Integration Info"
  >
  </aw-dialog>

  <aw-toast></aw-toast>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'New Third-Party Integration'"
    [altColor]="false"
  >
  </aw-divider>


  <div class="form-container">
    <!-- Integration Name Field -->
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      [multiline]="true"
      title="Third-Party Integration Name"
      [maxCharacters]="nameMaxLength"
      [allowedPattern]="namePattern"
      [patternMessage]="namePatternMessage"
      (textEntry)="onIntegrationNameSelected($event)"
    ></app-aw-text-form>

    <!-- Integration Status Field -->
    <app-aw-dropdown-form
      class="input"
      [options]="statusOptions()"
      title="Status"
      (currentOption)="onIntegrationStatusSelected($event)"
    ></app-aw-dropdown-form>
  </div>
  <div class="api-auth-details-container">
    <aw-divider
      [inset]="false"
      [middleInset]="false"
      [subTitle]="'API Authentication'"
      [altColor]="true"
    >
    </aw-divider>

    <app-aw-dropdown-form
      class="singular-input"
      [options]="apiAuthTypeOptions()"
      title="Authentication Type"
      (currentOption)="onIntegrationAuthTypeSelected($event)"
    ></app-aw-dropdown-form>

    @if (apiAuthTypeInput) {
    <app-aw-auth-form
      [authType]="apiAuthTypeValue"
      [values]="apiAuthValues"
      [authenticationVersion]="'api'"
      (valuesChangedEvent)="onApiAuthValuesChanged($event)"
    ></app-aw-auth-form>
    }
  </div>

  <div class="employee-auth-details-container">
    <aw-divider
      [inset]="false"
      [middleInset]="false"
      [subTitle]="'Third-Party Employee Authentication'"
      [altColor]="true"
    >
    </aw-divider>

    <app-aw-dropdown-form
      class="singular-input"
      [options]="employeeAuthTypeOptions()"
      title="Authentication Type"
      [label]="employeeAuthTypeInput"
      [required]="false"
      (currentOption)="onEmployeeAuthTypeSelected($event)"
    ></app-aw-dropdown-form>

    @if (employeeAuthTypeInput) {
    <app-aw-auth-form
      [authType]="employeeAuthTypeValue"
      [values]="employeeAuthValues"
      [editMode]="true"
      [authenticationVersion]="'employee'"
      (valuesChangedEvent)="onEmployeeAuthValuesChanged($event)"
    ></app-aw-auth-form>
    }
  </div>
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"></aw-action-bar>
</div>
